import { createTheme } from "@mui/material";
import { red } from "@mui/material/colors";

// Create a theme instance.
let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      xms: 400,
      sm: 567,
      md: 650,
      lg: 992,
      xl: 1440,
    },
  },
  palette: {
    common: {
      black: "#000000",
      white: "#ffffff",
      grey: "#D9D9D9",
      darkBlue: "#003260",
      lightBlue: "#D9EDFF",
      darkPurple: "#483d8b",
      lightPurple:"#cacce1",

      pageBackground: "#FBFBFF",
      green: "#479706",
      orange: "#FBBF24",
      borderColor: "#0094EC",
    },

    primary: {
      light: "#728ff8",
      main: "#0094EC",
      dark: "#0f40ec",
      contrastText: "#ffffff",
    },

    secondary: {
      light: "#067ae6",
      main: "#0053A0",
      dark: "#0053A0",
      contrastText: "#ffffff",
    },
    text: {
      primary: "#000000",
    },
    error: {
      main: red.A700,
    },
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",

    lineHeight: 1.3,
    fontWeightRegular: "400",
    fontWeightMedium: "500",
    fontWeightSemibold: "600",
    fontWeightBold: "700",
  },
});

theme = createTheme({
  ...theme,
  typography: {
    h1: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "600",
      fontSize: "32px",

      lineHeight: "48px",
      letterSpacing: "normal",
      [theme.breakpoints.down("md")]: {
        fontSize: "28px",
        lineHeight: "36px",
      },
    },
    h2: {
      fontFamily: "'Open Sans', sans-serif",
      fontWeight: "500",

      fontSize: "24px",
      lineHeight: "36px",
      letterSpacing: "normal",
    },
    h3: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "500",
      fontSize: "22px",
      lineHeight: "32px",
      letterSpacing: "normal",
      [theme.breakpoints.down("md")]: {
        fontSize: "18px",
        lineHeight: "28px",
      },
    },
    subtitle1: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "500",
      fontSize: "24px",
      lineHeight: "28px",
      letterSpacing: "normal",
      [theme.breakpoints.down("md")]: {
        fontSize: "18px",
        lineHeight: "28px",
      },
    },
    subtitle2: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "400",
      fontSize: "18px",
      lineHeight: "22px",
      letterSpacing: "normal",
      [theme.breakpoints.down("md")]: {
        fontSize: "16px",
        lineHeight: "20px",
      },
    },
    body1: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "20px",
    },
    body2: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "400",
      fontSize: "14px",
    },
    button: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "400",
    },
    caption: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "400",
      fontSize: "12px",
    },
    overline: {
      fontFamily: "'Open Sans', sans-serif",

      fontWeight: "400",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "capitalize",
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        notchedOutline: {
          borderColor: theme.palette.common.borderColor,
        },
      },
    },

    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
        },
      },
    },
  },
});

export default theme;
